export const LOADING_SPINNER_CONSTANTS = {
  DEFAULT_SIZE: 'default' as const,
  DEFAULT_TEXT: 'Loading',
  DEFAULT_PADDING: 8,
  DEFAULT_SHOW_TEXT: true,
  DEFAULT_FULL_SCREEN: false,
} as const;

export const SPINNER_SIZES = {
  SMALL: 'small',
  DEFAULT: 'default',
  LARGE: 'large',
} as const;
